import { createContext, useContext } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { hosts } from "../config/environment";

export const XhrContext = createContext();

export const XhrProvider = ({ children }) => {
    const { authState, logout } = useAuth();

    const contentType = 'application/json; charset=utf-8';

    function prefix() {
        return authState.authenticated ? '/api/v1' : "/exposed/v1";
    }

    function host() {
        const apiHost = hosts.api || '';
        return `${apiHost}${prefix()}`;
    }

    function getOptions(option, data) {
        option = option || {};
        option.headers = option.headers || {};
        
        // Si c'est du FormData, on ne définit pas 'Content-Type' manuellement
        if (!(data instanceof FormData)) {
            option.headers['Content-Type'] = option.headers['Content-Type'] || contentType;
        }
        option.headers['Accept'] = 'application/json';
        
        if (authState.authenticated && authState.access_token) {
            option.headers['Authorization'] = `Bearer ${authState.access_token}`;
        }
        
        return option;
    }

    function getQueryParameters(options) {
        if (!options.params || Object.keys(options.params).length === 0) {
            return '';
        }
        let query_params = '?' + Object.keys(options.params)
            .map((k) => k + '=' + encodeURIComponent(options.params[k]))
            .join('&');
        delete options.params;
        return query_params;
    }

    const getRequest = async (path, option) => {
        let options = await getOptions(option);
        let query_params = '';
        if (options.params) {
            query_params = getQueryParameters(options);
        }
        const fullUrl = `${host()}${path}${query_params}`;
        console.log('[XhrContext] GET:', fullUrl);
        return axios.get(fullUrl, options).catch(error => {
            if (error.response) {
                const status = error.response.status;
                if (status === 401 || status === 403) {
                    console.warn('[XhrContext] Erreur d\'authentification, déconnexion...');
                    logout();
                }
            }
            throw error;
        });
    };

    const postRequest = async (path, data, option) => {
        let options = await getOptions(option, data);
        let query_params = '';
        if (options.params) {
            query_params = getQueryParameters(options);
        }
        const fullUrl = `${host()}${path}${query_params}`;
        console.log('[XhrContext] POST:', fullUrl, data);
        return axios.post(fullUrl, data, options).catch(error => {
            if (error.response) {
                const status = error.response.status;
                if (status === 401 || status === 403) {
                    console.warn('[XhrContext] Erreur d\'authentification, déconnexion...');
                    logout();
                }
            }
            throw error;
        });
    };

    const putRequest = async (path, data, option) => {
        let options = await getOptions(option);
        let query_params = '';
        if (options.params) {
            query_params = getQueryParameters(options);
        }
        const fullUrl = `${host()}${path}${query_params}`;
        console.log('[XhrContext] PUT:', fullUrl, data);
        return axios.put(fullUrl, data, options).catch(error => {
            if (error.response) {
                const status = error.response.status;
                if (status === 401 || status === 403) {
                    console.warn('[XhrContext] Erreur d\'authentification, déconnexion...');
                    logout();
                }
            }
            throw error;
        });
    };

    const removeRequest = async (path, option) => {
        let options = await getOptions(option);
        let query_params = '';
        if (options.params) {
            query_params = getQueryParameters(options);
        }
        const fullUrl = `${host()}${path}${query_params}`;
        console.log('[XhrContext] DELETE:', fullUrl);
        return axios.delete(fullUrl, options).catch(error => {
            if (error.response) {
                const status = error.response.status;
                if (status === 401 || status === 403) {
                    console.warn('[XhrContext] Erreur d\'authentification, déconnexion...');
                    logout();
                }
            }
            throw error;
        });
    };

    return (
        <XhrContext.Provider value={{ removeRequest, postRequest, getRequest, putRequest }}>
            {children}
        </XhrContext.Provider>
    );
};











